import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
// import styles from 'src/Assets/css/home/post.module.css'
// import saysoutlineimage from 'src/Assets/images/saysoutline.png'
// import follow from 'src/Assets/images/followicon.png'
// import dropdownarrow from "src/Assets/images/dropdownarrow.png";
import locationIcon from "src/Assets/images/userlocationtag.png";
import dot from "src/Assets/images/dot.png";
import smallike from "src/Assets/images/smallike.png";
// import like from 'src/Assets/images/like.png'
import feedstyles from "src/Assets/css/home/feedpost.module.css";
import alreadyImpactfulMemberImg from "src/Assets/images/already_impactful_img.png";
// import deleteicon from "src/Assets/images/deleteicon.png";
import edit from "src/Assets/images/edit.png";
import unlike from "src/Assets/images/unlike.png";
import sendanemail from "src/Assets/images/sendanemail.png";
import ReusuableDeleteDialogmodal from "../../../Modules/Reusuablecomponents/ReusuableDeleteModal";
import styles from "src/Assets/css/home/post.module.css";
// import PostMessageValidation from "../../../Modules/Reusuablecomponents/PostMessageValidation";
import SimpleDialogDemo from "../../../Modules/Reusuablecomponents/CustomizedDialogs";
import { CircularProgress } from "@material-ui/core";
import API from "../../../network";
import ReusuableReportDialogmodal from "src/Modules/Reusuablecomponents/ReusuableReportDialogmodal";
import ReusuableSendaMailModal from "src/Modules/Reusuablecomponents/ReusuableSendaMailModal";
import { Menu, MenuItem } from "@szhsin/react-menu";
import { PiDotsThreeBold } from "react-icons/pi";
import IconButton from "@material-ui/core/IconButton";
import AvatarBadge from "src/Components/AvatarBadge";
import ReportModal from "../../../Modules/Reusuablecomponents/reportModal";
import closeIcon from "src/Assets/images/CloseButton.svg";
import {
  CommonModalContext,
  ModalType,
} from "src/context/CommonModalContext/CommonModalContext";
import {
  capitalizeFirstLetter,
  ignoreSpacesAndUrlsFromMsg,
} from "src/Utils/commonUtils";
import EditLocation from "src/Utils/editLocation";
import MapDialog from "./LocationAddress";
import TextWithUrlsAndHashTags from "src/Components/TextWithUrlsAndHashTags";
import TruncatedTextWithTooltip from "../../../Utils/truncatedTextWithTooltip";
import PostAttachmentViewer from "src/Utils/PostAttachmentViewer";
import AttachmentUploader from "src/Utils/AttachmentUploader";
import { ProfileHoverCard } from "./ProfileHoverCard";

function ChildSay(props) {
  const {
    fetchVoteUpStatus,
    loading,
    deleteMessage,
    deleteSayCount,
    isActionDisabled,
    sayOrAskPost,
    fetchContributors,
    flow,
    onActionSuccess,
    onHashTagClick: propOnHashTagClick,
  } = props;

  // const [isliked, setLiked] = React.useState(false)
  // var profileimagelocalPath = "http://localhost:8080/skopicimage";
  var profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;
  const userDetails = useSelector(
    (state) => state.SignInReducer?.userDetails || {},
  );
  const [childSaysData, setChildSaysData] = useState(null);
  const [editPostId, setEditPostId] = useState(null);
  const [updatedMsg, setUpdatedMsg] = useState("");
  const [updatedMsgCount, setUpdatedMsgCount] = useState(0);
  const [emailPopupOpen, setEmailPopupOpen] = useState(false);
  const [textValue, setTextValue] = useState("");
  const [textCount, setTextCount] = useState(280);
  const [selectedPost, setSelectedPost] = useState({});
  const [validationErrMsg, setValidationErrMsg] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [locationAddress, setLocationAddress] = useState("");
  const [openMap, setOpenMap] = useState(false);
  const commonModalContext = useContext(CommonModalContext);
  const [activeTooltip, setActiveTooltip] = useState(null);
  const [attachment, setAttachment] = useState(null);
  const [isAttacmentDeleted, setIsAttacmentDeleted] = useState(null);
  const [clickedLocation, setClickedLocation] = useState({
    locAddress: "",
    latitude: "",
    longitude: "",
  });
  const startLimitRef = useRef(0);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);

  const [location, setLocation] = useState({
    selectedAddress: locationAddress,
    latitude: latitude,
    longitude: longitude,
  });

  const onHashTagClick = (hashTag) => {
    if (propOnHashTagClick) {
      propOnHashTagClick(hashTag);
      return;
    }
    if (typeof hashTag === "object") {
      commonModalContext?.onOpen(ModalType.SEARCH_TAG, {
        hashTag: hashTag.hashtag,
        tagActivityTenantId: hashTag.tenantId,
        isActionDisabled,
        onActionSuccess,
      });
    } else {
      commonModalContext?.onOpen(ModalType.SEARCH_TAG, {
        hashTag,
        isActionDisabled,
        onActionSuccess,
      });
    }
  };

  useEffect(() => {
    let msg = textValue || "";
    // msg = msg.replace(/\n/g, "");
    // msg = msg.replace(/\s/g, "");
    const count = msg.length;
    setTextCount(count);
  }, [textValue]);

  const handleLocationUpdate = (address, lat, lng) => {
    setLocation({
      selectedAddress: address,
      latitude: lat,
      longitude: lng,
    });
  };

  const handleLocationDelete = (id) => {
    setLocation({
      selectedAddress: "",
      latitude: "",
      longitude: "",
    });
    const updatedMessageList = childSaysData.childSAYsMessageList.map(
      (item) => {
        if (item.id === id) {
          return {
            ...item,
            locName: "",
            newSelectedLocation: "",
          }; // Update the message
        }
        return item; // Return unchanged items
      },
    );
    setChildSaysData({
      ...childSaysData,
      childSAYsMessageList: updatedMessageList,
    });
  };

  const handleClickOpen = (address, lat, lng) => {
    setOpenMap(true);
    setClickedLocation({
      locAddress: address,
      latitude: lat,
      longitude: lng,
    });
  };

  const handleCloseMap = () => {
    setOpenMap(false);
  };

  useEffect(() => {
    let msg = updatedMsg || "";
    // msg = msg.replace(/\n/g, "");
    // msg = msg.replace(/\s/g, "");
    const { msgLength } = ignoreSpacesAndUrlsFromMsg(msg);
    setUpdatedMsgCount(msgLength);
  }, [updatedMsg]);

  useEffect(() => {
    setChildSaysData(props.childSaysData);
      startLimitRef.current = 0;
      setHasMore(true);
  }, [props.childSaysData]);

  const likeUnlike = (id) => {
    const newUpdatedList = childSaysData.childSAYsMessageList.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          UserLikeStatus: "InActive",
          voteUp: item.voteUp - 1 + 2,
        }; // Update the message
      }
      return item; // Return unchanged items
    });
    setChildSaysData({
      ...childSaysData,
      childSAYsMessageList: newUpdatedList,
    });
  };


const loadMoreChildSays = useCallback(async () => {
  if (loadingMore || !hasMore) return;

  try {
    setLoadingMore(true);

    const nextStartLimit = startLimitRef.current + 10;

    const response = await API.fetchChildSaysData(
      props.id,
      false,
      false,
      nextStartLimit,
    );

    const newRecords = response?.data?.childSAYsMessageList || [];

    if (newRecords.length === 0) {
      setHasMore(false);
      return;
    }

    setChildSaysData((prev) => ({
      ...prev,
      childSAYsMessageList: [
        ...(prev?.childSAYsMessageList || []),
        ...newRecords,
      ],
    }));

    // Update ref after successful append
    startLimitRef.current = nextStartLimit;

    if (newRecords.length < 10) {
      setHasMore(false);
    }
  } catch (err) {
    console.error(err);
  } finally {
    setLoadingMore(false);
  }
}, [loadingMore, hasMore, props.id]);

  const onChildLikeUnlikeSelection = (id, cache) => {
    if (isActionDisabled) return;
    likeUnlike(id);
    fetchVoteUpStatus(id, cache);
  };

  const deletePost = (id) => {
    const newUpdatedList = childSaysData.childSAYsMessageList.filter(
      (item) => item.id !== id,
    );
    setChildSaysData({
      ...childSaysData,
      childSAYsMessageList: newUpdatedList,
    });
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    const isBottom = scrollHeight - scrollTop <= clientHeight + 20;

    if (isBottom) {
      loadMoreChildSays();
    }
  };

  const onEditSelection = (id, msg, latitude, longitude, locationAddress) => {
    setEditPostId(id);
    const cleanedMsg = msg ? msg.trimEnd() : "";
    setUpdatedMsg(cleanedMsg);
    setLatitude(latitude);
    setLongitude(longitude);
    setLocationAddress(locationAddress);
    setLocation({
      selectedAddress: locationAddress,
      latitude: latitude,
      longitude: longitude,
    });
  };

  const saveMessage = async (id, defaultMsg) => {
    const isAttachmentUpdated = isAttacmentDeleted === "success" ? true : false;
    const cleanDefault = defaultMsg ? defaultMsg.trimEnd() : "";
    const cleanUpdated = updatedMsg ? updatedMsg.trimEnd() : "";
    if (
      cleanDefault === cleanUpdated &&
      (locationAddress || "") === (location?.selectedAddress || "") &&
      !attachment &&
      !isAttachmentUpdated
    ) {
      setValidationErrMsg("At least one modification required");
      return;
    }

    try {
      const newUpdatedMsg = cleanUpdated.length > 0 ? cleanUpdated : cleanDefault;
      const tempUrl =
        attachment instanceof File ? URL.createObjectURL(attachment) : null;
      const urlRegex =
        /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9-]+\.(com|org|net|io|co|in|edu|gov|me|info|biz|dev|app|store|tech)[^\s]*)/gi;
      const extractedUrls = newUpdatedMsg
        ? newUpdatedMsg.match(urlRegex) || []
        : [];

      const isTextModified = cleanUpdated.length > 0 && cleanUpdated !== cleanDefault;
      const isAttachmentAdded = attachment instanceof File;
      const isContentEdited = isTextModified || isAttachmentAdded;

      const updatedMessageList = childSaysData.childSAYsMessageList.map(
        (item) => {
          if (item.id === id) {
            const { newSelectedLocation, ...cleanItem } = item;
            return {
              ...cleanItem,
              Message: newUpdatedMsg,
              url: extractedUrls.length > 0 ? extractedUrls : item?.url,
              locName: location?.selectedAddress || "",
              msgLat: location?.selectedAddress ? location?.latitude || item?.msgLat : "",
              msgLng: location?.selectedAddress ? location?.longitude || item?.msgLng : "",
              docName: attachment?.name || item.docName || "",
              docLocation: tempUrl || item.docLocation || "",
              docTagged: attachment ? 1 : item.docTagged,
              ...(isContentEdited ? { updated_time: "1m", edited: 1 } : {}),
            }; // Update the message
          }
          return item; // Return unchanged items
        },
      );
      const formdata = new FormData();
      if (location?.latitude && location?.longitude) {
        const lat = `${location.latitude},${location.longitude}`;
        formdata.append("msgLoc", lat);
      }
      if (location?.selectedAddress) {
        formdata.append("locName", location.selectedAddress);
      }

      formdata.append("userLoc", "");
      formdata.append("messageID", id);
      formdata.append("message", newUpdatedMsg);
      const res = await API.editPostLocation(formdata);
      if (res?.data?.status === "New Hash") {
        setValidationErrMsg("You can't create a New hash tag");
        return;
      }
      if (attachment) {
        const attachmentFormData = new FormData();
        attachmentFormData.append("file", attachment);
        attachmentFormData.append("messageID", id);

        await API.updateAttachment(attachmentFormData);
      }
      setChildSaysData({
        ...childSaysData,
        childSAYsMessageList: updatedMessageList,
      });
      setEditPostId(null);
      window.dispatchEvent(
        new CustomEvent("postUpdated", {
          detail: {
            id,
            message: newUpdatedMsg,
            locationName: location?.selectedAddress,
            attachment,
          },
        }),
      );
      setAttachment(null);
      setIsAttacmentDeleted?.(null);
      setValidationErrMsg("");
    } catch (error) {
      console.log(error);
    }
  };

  const updateNewSelectedLocation = (newSelectedLoc) => {
    const updatedMessageList = childSaysData.childSAYsMessageList.map(
      (item) => {
        if (item.id === editPostId) {
          return {
            ...item,
            newSelectedLocation: newSelectedLoc,
          }; // Update the message
        }
        return item; // Return unchanged items
      },
    );
    setChildSaysData({
      ...childSaysData,
      childSAYsMessageList: updatedMessageList,
    });
  };

  const removeNewSelectedLocationKey = () => {
    const updatedMessageList = childSaysData.childSAYsMessageList.map(
      (item) => {
        // Create a copy of the object without mutating the original
        const { newSelectedLocation, ...rest } = item; // Destructure and exclude the temporary key
        return rest; // Return the object without the temporary key
      },
    );
    setChildSaysData({
      ...childSaysData,
      childSAYsMessageList: updatedMessageList,
    }); // Update the state with the cleaned array
  };

  const handleDeleteAttachementDoc = async (id) => {
    try {
      const response = await API.deleteAttachment(id);

      if (response?.data?.status === "success") {
        alert("Attachment deleted successfully!");

        // Update UI immediately without mutating state
        const updatedMessageList = childSaysData.childSAYsMessageList.map(
          (item) => {
            if (item.id === id) {
              return {
                ...item,
                docName: null,
                docLocation: null,
                docTagged: 0,
              }; // Update the message
            }
            return item; // Return unchanged items
          },
        );
        setChildSaysData({
          ...childSaysData,
          childSAYsMessageList: updatedMessageList,
        });
        setIsAttacmentDeleted(response?.data?.status);
        setAttachment(null);
      }
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete attachment.");
    } finally {
      setActiveTooltip(null);
    }
  };

  const updateMessage = (e) => {
    const val = e.target.value ?? "";
    const formattedValue = capitalizeFirstLetter(val);
    setUpdatedMsg(formattedValue);
  };

  const cancelUpdateMsg = () => {
    removeNewSelectedLocationKey();
    setEditPostId(null);
    setValidationErrMsg("");
  };

  const setUpdatedText = (e) => {
    const val = e.target.value ?? "";
    const formattedValue = capitalizeFirstLetter(val);
    setTextValue(formattedValue);
  };

  const onSendMail = async (id) => {
    if (textValue?.trim()) {
      const response = await API.postMail(id, textValue);
      setEmailPopupOpen(false);
      setTextValue("");
      setTextCount(0);
      if (response?.data?.justFollowed) {
        onActionSuccess?.(() => {});
      }
    }
  };

  const onClickSendEmailOption = (selectedPost) => {
    setEmailPopupOpen(true);
    setSelectedPost(selectedPost);
    setTextValue("");
    setTextCount(0);
  };

  const notificationStatusArray = selectedPost?.mainuserdata?.notificationStatus
    ? selectedPost.mainuserdata.notificationStatus.split(",")
    : [];

  const mailRestrictionStatus = notificationStatusArray[8] || "";

  const isSendBtnEnabled = textValue && textCount > 0 && textCount <= 280;
  const isSaveBtnEnabled =
    updatedMsg && updatedMsgCount > 0 && updatedMsgCount <= 280;

  console.log(`childSaysData:`, childSaysData);

  return (
    <React.Fragment>
      {!loading ? (
        childSaysData && Object.keys(childSaysData).length !== 0 ? (
          childSaysData.childSAYsMessageList ? (
            <div
              style={{
                maxHeight: "500px",
                overflowY: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
              onScroll={handleScroll}
            >
              {childSaysData.childSAYsMessageList.map((childresult) => (
                <div key={`childSayKey${childresult.id}`} id={childresult.id}>
                  <div className={styles.postedcomment}>
                    <div className={feedstyles.avatarDetailsContainer}>
                      <div className={feedstyles.avatarContainer}>
                        <AvatarBadge
                          src={`${profileImagePath}${childresult.uimage}`}
                          variant="square"
                          className={styles.childsayprofileimage}
                          isChild={true}
                          isPrimaryModerator={
                            String(childresult?.mainuserdata?.isPM) === "1" &&
                            String(childresult?.mainuserdata?.isModerator) ===
                              "1"
                          }
                          isModerator={
                            String(childresult?.mainuserdata?.isModerator) ===
                              "1" &&
                            String(childresult?.mainuserdata?.isPM) === "0"
                          }
                        />
                        <ProfileHoverCard
                          result={childresult}
                          flow={props.flow || flow}
                          isActionDisabled={props.isActionDisabled || isActionDisabled}
                          onActionSuccess={props.onActionSuccess || onActionSuccess}
                        />
                      </div>
                    </div>

                    <div className={styles.profileimagetext}>
                      <div className={styles.childsaysprofileandfdropdown}>
                        <span className={feedstyles.profilename}>
                          {childresult.mainuserdata.displayName}
                          {(childresult?.mainuserdata?.isImpactableMember ===
                            "yes" ||
                            childresult?.isImpactableMember === "yes") && (
                            <img
                              src={alreadyImpactfulMemberImg}
                              alt="Impactful Member"
                              title="Impactful Member"
                              style={{
                                width: "18px",
                                height: "18px",
                                objectFit: "contain",
                                flexShrink: 0,
                                marginLeft: "5px",
                              }}
                            />
                          )}
                        </span>
                        {!isActionDisabled && (
                          <div
                            className={feedstyles.feeddropdown}
                            style={{ position: "relative", right: "-4px" }}
                          >
                            <Menu
                              portal={true}
                              viewScroll="close"
                              position="anchor"
                              reposition="auto"
                              menuButton={
                                <IconButton
                                  style={{
                                    padding: 0,
                                    width: 30,
                                    height: 30,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {/* <MdKeyboardArrowDown fontSize={25} /> */}
                                  <PiDotsThreeBold
                                    fontSize={25}
                                    color="rgba(0, 0, 0, 0.7)"
                                  />
                                </IconButton>
                              }
                              transition
                              direction="bottom"
                              arrow
                              menuStyle={{
                                backgroundColor: "white",
                                borderRadius: 20,
                              }}
                              align="end"
                            >
                              {childresult.User_ID !==
                              userDetails?.userData?.User_ID ? (
                                <>
                                  {childresult.moderatorStatus === "1" ? (
                                    <>
                                      <MenuItem>
                                        <ReusuableDeleteDialogmodal
                                          type={childresult.message_type}
                                          id={childresult.id}
                                          Parent_ID={childresult.Parent_ID}
                                          deleteMessage={deleteMessage}
                                          deletePost={deletePost}
                                          deleteSayCount={
                                            deleteSayCount && deleteSayCount
                                          }
                                          fetchContributors={fetchContributors}
                                        />
                                      </MenuItem>
                                      <MenuItem
                                        onClick={() =>
                                          onClickSendEmailOption(childresult)
                                        }
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "100%",
                                            height: "100%",
                                            padding: "0.375rem 1.5rem",
                                            boxSizing: "border-box",
                                            cursor: "pointer",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          <img
                                            src={sendanemail}
                                            style={{
                                              width: 18,
                                              height: 18,
                                              marginRight: 8,
                                              flexShrink: 0,
                                              objectFit: "contain",
                                            }}
                                            alt=""
                                          />
                                          <span
                                            style={{
                                              fontSize: 14,
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {" "}
                                            Send email to{" "}
                                            {childresult.displayName}
                                          </span>
                                        </div>
                                      </MenuItem>
                                    </>
                                  ) : (
                                    <>
                                      {sayOrAskPost &&
                                      sayOrAskPost === "sayOrAskPost" ? (
                                        <MenuItem>
                                          <ReportModal
                                            id={childresult.id}
                                            param={"AskorSay"}
                                            onActionSuccess={onActionSuccess}
                                          />
                                        </MenuItem>
                                      ) : (
                                        <MenuItem>
                                          <ReusuableReportDialogmodal
                                            id={childresult.id}
                                            param={"AskorSay"}
                                            onActionSuccess={onActionSuccess}
                                          />
                                        </MenuItem>
                                      )}
                                      <MenuItem>
                                        <ReusuableSendaMailModal
                                          displayName={childresult.displayName}
                                          id={childresult.id}
                                          notificationStatus={
                                            childresult.mainuserdata
                                              .notificationStatus
                                          }
                                          onActionSuccess={onActionSuccess}
                                        />
                                      </MenuItem>
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  <MenuItem
                                    onClick={() =>
                                      onEditSelection(
                                        childresult.id,
                                        childresult?.Message,
                                        childresult.msgLat,
                                        childresult.msgLng,
                                        childresult.locName,
                                      )
                                    }
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        width: "100%",
                                        height: "100%",
                                        padding: "0.375rem 1.5rem",
                                        boxSizing: "border-box",
                                        cursor: "pointer",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      <img
                                        src={edit}
                                        style={{
                                          width: 18,
                                          height: 18,
                                          marginRight: 8,
                                          flexShrink: 0,
                                          objectFit: "contain",
                                        }}
                                        alt="edit"
                                      />
                                      <span
                                        style={{
                                          fontSize: 14,
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        Edit
                                      </span>
                                    </div>
                                  </MenuItem>
                                  <MenuItem>
                                    <ReusuableDeleteDialogmodal
                                      type={childresult.message_type}
                                      id={childresult.id}
                                      Parent_ID={childresult.Parent_ID}
                                      deleteMessage={deleteMessage}
                                      deletePost={deletePost}
                                      deleteSayCount={
                                        deleteSayCount && deleteSayCount
                                      }
                                      fetchContributors={fetchContributors}
                                    />
                                  </MenuItem>
                                </>
                              )}
                            </Menu>
                          </div>
                        )}
                      </div>
                      <div className={styles.childsaytextandcolorlabel}>
                        {editPostId === childresult.id ? (
                          <div>
                            <div className={styles.textareaContainer}>
                              <textarea
                                rows="2"
                                cols="70"
                                value={updatedMsg}
                                // defaultValue={childresult.Message}
                                onChange={(e) => updateMessage(e)}
                                onFocus={() => setValidationErrMsg("")}
                                className={styles.EditPostMessage}
                                style={{ padding: "10px 10px 10px 10px" }}
                              />
                            </div>
                            {validationErrMsg && (
                              <div style={{ fontSize: 11, color: "red" }}>
                                {validationErrMsg}
                              </div>
                            )}
                            <div
                              className={
                                styles.postAttachmentIconsAndActionBtnMainTopContainer
                              }
                            >
                              <div className={styles.saveCancelButtonContainer}>
                                <div
                                  className={
                                    styles.postAttachmentIconsContainer
                                  }
                                >
                                  <div
                                    className={
                                      styles.postLocationAttachmentTextContainer
                                    }
                                  >
                                    <EditLocation
                                      postLattitude={latitude}
                                      postLongitude={longitude}
                                      onLocationChange={handleLocationUpdate}
                                      updateNewSelectedLocation={
                                        updateNewSelectedLocation
                                      }
                                    />
                                    {location.selectedAddress && (
                                      <div
                                        className={styles.childfileLocationItem}
                                      >
                                        <span
                                          className={
                                            styles.childfileLocationName
                                          }
                                        >
                                          {location.selectedAddress}
                                        </span>
                                        <button
                                          type="button"
                                          onClick={() =>
                                            handleLocationDelete(childresult.id)
                                          }
                                          className={styles.removeBtn}
                                        >
                                          <img
                                            src={closeIcon}
                                            alt="closeIcon"
                                            className={styles.deleteIcon}
                                          />
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                  <AttachmentUploader
                                    onFileSelect={setAttachment}
                                    allowMultiple={false}
                                    docName={childresult?.docName}
                                    onDeleteAttachment={
                                      handleDeleteAttachementDoc
                                    }
                                    editPostId={childresult?.id}
                                  />
                                </div>
                                {!location.selectedAddress &&
                                  !childresult?.docName &&
                                  !attachment && (
                                    <div
                                      className={styles.saveCancelBtnContainer}
                                    >
                                      <button
                                        onClick={() =>
                                          saveMessage(
                                            childresult.id,
                                            childresult.Message,
                                          )
                                        }
                                        className={styles.editPost}
                                        disabled={!isSaveBtnEnabled}
                                        style={{
                                          backgroundColor: !isSaveBtnEnabled
                                            ? "#60A2E0"
                                            : "#127ADD",
                                        }}
                                      >
                                        Save
                                      </button>
                                      <button
                                        onClick={cancelUpdateMsg}
                                        className={styles.editCancelPost}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  )}
                                <span
                                  style={{
                                    color:
                                      updatedMsgCount > 280 ? "red" : "black",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    fontSize: "14px",
                                  }}
                                >
                                  {updatedMsgCount}
                                  <span
                                    style={{ color: "black", fontSize: "14px" }}
                                  >
                                    /280
                                  </span>
                                </span>
                              </div>
                              {(location.selectedAddress ||
                                childresult?.docName ||
                                attachment) && (
                                <div
                                  className={styles.saveCancelBtnContainer}
                                  style={{ margin: "auto" }}
                                >
                                  <button
                                    onClick={() =>
                                      saveMessage(
                                        childresult.id,
                                        childresult.Message,
                                      )
                                    }
                                    className={styles.editPost}
                                    disabled={!isSaveBtnEnabled}
                                    style={{
                                      backgroundColor: !isSaveBtnEnabled
                                        ? "#60A2E0"
                                        : "#127ADD",
                                    }}
                                  >
                                    Save
                                  </button>
                                  <button
                                    onClick={cancelUpdateMsg}
                                    className={styles.editCancelPost}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "flex-end", // aligns with text bottom
                              flexWrap: "wrap",
                              gap: "5px", // small gap between text and file name
                            }}
                          >
                            <p
                              id={`hide${childresult.id}`}
                              style={{ wordBreak: "break-word" }}
                            >
                              <TextWithUrlsAndHashTags
                                text={childresult.Message}
                                urls={[childresult.url]}
                                hashtags={childresult.tag}
                                tagActivityTenantId={childSaysData?.tenantID}
                                onHashtagClick={onHashTagClick}
                              />
                            </p>
                            <PostAttachmentViewer
                              docLocation={childresult.docLocation}
                              userId={childresult.User_ID}
                              docTagged={childresult.docTagged}
                              docName={childresult.docName}
                              messageID={childresult.id}
                              className={feedstyles.myFileNameSpacingAllFeed}
                              activeTooltip={activeTooltip}
                              setActiveTooltip={setActiveTooltip}
                              onDeleteAttachment={handleDeleteAttachementDoc}
                            />
                          </div>
                        )}
                        {/* <div>
                        <p id={`hide${childresult.id}`}>
                          {childresult.Message}
                        </p>
                        <span
                          className={feedstyles.edittextarea}
                          id={`edittext${childresult.id}`}
                        >
                          <PostMessageValidation
                            id={childresult.id}
                            parentId={props.id}
                            Message={childresult.Message}
                            messageType={"feedTextArea"}
                            fetchFeedData={fetchFeedData}
                            refreshFeedData={refreshFeedData}
                          />
                        </span>
                      </div> */}
                        {/* <div className={styles.childsaycount}>
                        <span></span>
                      </div> */}
                      </div>
                    </div>
                  </div>
                  <div className={styles.likeandlikecount}>
                    <span className={styles.spandisplay}>
                      <div className={styles.likeunlike}>
                        {childresult.UserLikeStatus === "Active" ? (
                          <button
                            type="button"
                            style={{
                              background: "none",
                              border: "none",
                              padding: 0,
                              cursor: "pointer",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                            onClick={() =>
                              onChildLikeUnlikeSelection(
                                childresult.id,
                                "cacheUpdate",
                              )
                            }
                            id={`00${childresult.id}`}
                          >
                            <img src={smallike} alt="smalllike" />
                            Like
                          </button>
                        ) : (
                          <button
                            type="button"
                            style={{
                              background: "none",
                              border: "none",
                              padding: 0,
                              cursor: "pointer",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                            onClick={() =>
                              onChildLikeUnlikeSelection(
                                childresult.id,
                                "cacheUpdate",
                              )
                            }
                            className={feedstyles.childUnlike}
                          >
                            <img src={unlike} alt="unlike" />
                            Like
                          </button>
                        )}
                      </div>
                      <img src={dot} alt="dot" className={styles.dot} />
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {childresult.voteUp !== 0 ? (
                          <SimpleDialogDemo
                            voteUp={childresult.voteUp}
                            id={childresult.id}
                            isVoteup={"true"}
                            isActionDisabled={props.isActionDisabled || isActionDisabled}
                            onActionSuccess={props.onActionSuccess || onActionSuccess}
                          />
                        ) : (
                          <span className={styles.followcount}>
                            {childresult.voteUp === 1
                              ? `${childresult.voteUp} like`
                              : `${childresult.voteUp} likes`}
                          </span>
                        )}
                      </div>
                      {/* <a className={styles.nooflikes}>{childresult.voteUp} like</a> */}
                    </span>

                    <span
                      className={styles.locationTimeSpan}
                      style={{
                        display: "flex",
                        paddingRight: "10px",
                        justifyContent: childresult.locName
                          ? "flex-start"
                          : "flex-end",
                      }}
                    >
                      <img src={dot} alt="dot" className={styles.dot} />
                      <p className={styles.childsaytime}>
                        {childresult.Message_Time}{" "}
                        {childresult.edited === 1 && (
                          <span> (edited {childresult.updated_time})</span>
                        )}
                      </p>
                      <span
                        className={styles.locationandtime}
                        onClick={() => {
                          if (!isActionDisabled) {
                            handleClickOpen(
                              childresult.locName,
                              childresult.msgLat,
                              childresult.msgLng,
                            );
                          }
                        }}
                        style={{
                          cursor: isActionDisabled ? "default" : "pointer",
                          pointerEvents: isActionDisabled ? "none" : "auto",
                        }}
                      >
                        {childresult.locName && (
                          <>
                            <img src={dot} alt="dot" />
                            <img src={locationIcon} alt="location:" />
                          </>
                        )}
                        <div className={styles.childSayLocText}>
                          <TruncatedTextWithTooltip
                            text={
                              childresult.newSelectedLocation ||
                              childresult.locName
                            }
                          />
                        </div>
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p>No Say Data</p>
          )
        ) : (
          <p>No Say Data</p>
        )
      ) : (
        <CircularProgress className={feedstyles.Loader} />
      )}
      <Modal
        show={emailPopupOpen}
        style={{ backgroundColor: "#00000060", zIndex: 4000 }}
        contentClassName={styles.contentClass}
      >
        <Modal.Header
          closeButton
          style={{
            backgroundColor: "#fff",
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            borderBottomWidth: 0,
          }}
          onClick={() => setEmailPopupOpen(false)}
        >
          <Modal.Title>Send emails</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            borderBottomLeftRadius: 10,
            borderBottomRightRadius: 10,
            padding: 0,
          }}
        >
          {mailRestrictionStatus === "N" ? (
            <p>{`${selectedPost?.displayName} is not accepting emails`}</p>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <textarea
                rows="6"
                cols="44"
                className={styles.sendamailtextarea}
                id={`textInputMail${selectedPost?.id}`}
                // onInput={() => myFunction(props.id)}
                value={textValue}
                onChange={(e) => setUpdatedText(e)}
                placeholder={`What would you like to say to ${selectedPost?.displayName}`}
              />
              <span
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                  color: textCount > 280 ? "red" : "black",
                }}
              >
                {textCount}
                <span style={{ color: "black" }}>/280</span>
              </span>
              <button
                type="button"
                id={`buttonforEdit${selectedPost?.id}`}
                className={styles.sendaMail}
                style={{
                  top: 0,
                  left: 0,
                  backgroundColor: !isSendBtnEnabled ? "#60A2E0" : "#127ADD",
                }}
                onClick={() => onSendMail(selectedPost?.id)}
                disabled={!isSendBtnEnabled}
              >
                Send
              </button>
            </div>
          )}
        </Modal.Body>
      </Modal>
      <MapDialog
        open={openMap}
        onClose={handleCloseMap}
        clickedLocation={clickedLocation}
        zoomLevel={12}
      />
      {loadingMore && (
        <div style={{ textAlign: "center", padding: 10 }}>Loading more...</div>
      )}
    </React.Fragment>
  );
}

export default ChildSay;
